module.exports = __webpack_public_path__ + "media/images/br-flag-7af8f9a0527e642185761280af256cf7.png";